import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import {checkdomain} from "../../utils/utils";

export default class LeftPanel extends Component{
  constructor(props) {
    super(props);
    this.state = {
      admin: ''
    };
  }
  componentWillMount() {
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    if (checkdomain(tenantname)) {
      return this.setState({admin: "isos"});
    }
  }
  render() {
    let { admin } = this.state;
    let adminName =  sessionStorage.getItem("adminName") || "User";
    return (
      <aside id="left-panel">
        <nav>
          <ul style={{borderBottom: "1px solid #525151"}}>
            <li data-toggle="modal" data-target="#psModal">
              <a href="javascript:">
                <i className="fa fa-lg fa-fw fa-user" />
                <span className="menu-item-parent">
                  {adminName}
                </span>
              </a>
            </li>
            {
              admin === "isos" &&
              <li style={{borderBottom: "1px solid #1A1817"}}>
                <NavLink to='/admin/tenant' activeStyle={{ color: '#fff'}}>
                  <i className="fa fa-lg fa-fw fa-group" />
                  <span className="menu-item-parent">
                    Tenant Management
                  </span>
                </NavLink>
              </li>
            }
          </ul>
        </nav>
        <nav>
          <ul id="ulList">
            <li>
              <NavLink to='/admin/dashboard' activeStyle={{ color: '#fff'}}>
                <i className="fa fa-lg fa-fw fa-home" />
                <span className="menu-item-parent">Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink to='/admin/subscribers' activeStyle={{ color: '#fff'}}>
                <i className="fa fa-lg fa-fw fa-address-book-o" />
                <span className="menu-item-parent">
                  Subscriber Management
                </span>
              </NavLink>
            </li>
            <li>
              <NavLink to='/admin/bounceEmail' activeStyle={{ color: '#fff'}}>
                <i className="fa fa-lg fa-fw fa-envelope-o" />
                <span className="menu-item-parent">
                  Bounce Email
                </span>
              </NavLink>
            </li>
          </ul>
        </nav>
        <span className="minifyme" data-action="minifyMenu">
          <i className="fa fa-arrow-circle-left hit" />
        </span>
      </aside>
    );
  }
}


// WEBPACK FOOTER //
// ./src/component/dashboard/leftPanel.js